import { computed } from 'vue';
import { type RouteRecordRaw } from 'vue-router';

import { useGlobalI18n } from '@abaninja/util-i18n';

const { global: { t } } = useGlobalI18n();

export const routes: RouteRecordRaw[] = [
  {
    name: 'subscriptions',
    path: 'subscriptions',
    component: () => import('../SubscriptionIndex.vue'),
    meta: {
      permissions: ['ADMIN'],
      title: computed(() => t('messages.subscription', 2)),
    },
  },
];
